const SupplierDetailForm = ({ formData, setFormData, onSubmit, onCancel, saving }) => {
  return (
    <div className="detail-card full-width">
      <div className="card-header">
        <h3>✏️ Edit Supplier</h3>
      </div>
      <div className="card-content">
        <form onSubmit={onSubmit}>
          <div className="form-group">
            <label htmlFor="supplier_name">Supplier Name *</label>
            <input
              type="text"
              id="supplier_name"
              value={formData.supplier_name}
              onChange={(e) => setFormData({ ...formData, supplier_name: e.target.value })}
              className="form-input"
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              value={formData.status}
              onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              className="form-select"
            >
              <option value="completed">Completed</option>
              <option value="processing">Processing</option>
              <option value="failed">Failed</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="instructions">Extraction Instructions</label>
            <textarea
              id="instructions"
              value={formData.instructions}
              onChange={(e) => setFormData({ ...formData, instructions: e.target.value })}
              className="form-textarea"
              rows="6"
              placeholder="Example: PO/order number may be random numeric or start with O; extract it exactly as printed."
            />
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.isfewshot}
                onChange={(e) => setFormData({ ...formData, isfewshot: e.target.checked })}
              />
              <span>Is Few Shot</span>
            </label>
          </div>

          <div className="form-group">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={formData.process_all_pages}
                onChange={(e) => setFormData({ ...formData, process_all_pages: e.target.checked })}
              />
              <span>Extract from all document pages</span>
            </label>
          </div>

          <div className="form-actions">
            <button type="button" className="btn-secondary" onClick={onCancel}>
              Cancel
            </button>
            <button type="submit" className="btn-primary" disabled={saving}>
              {saving ? '💾 Saving...' : '💾 Save Changes'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SupplierDetailForm;
